import * as React from 'react';
import SvgIcon from 'material-ui/SvgIcon';

export class HorizontalAlignLeft extends React.Component<__MaterialUI.SvgIconProps, {}> {

    render() {
        return (
            <SvgIcon {...this.props}>
                <path
                    transform="rotate(90 12 12)"
                    d="M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z"
                />
            </SvgIcon>
        );
    }

}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/custom-components/svg-icons/align/HorizontalAlignLeft.tsx
 **/